import type { Control, FieldValues } from 'react-hook-form';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { OptionBuilderProps } from './option-builder.component';
import OptionBuilder from './option-builder.component';

export interface HfOptionBuilderProps extends OptionBuilderProps {
  control: Control<FieldValues>;
  name: string;
}

const HfOptionBuilder = ({
  control,
  name,
  id,
  data,
  value,
  textField,
  valueField,
  label,
  fieldValueConverter,
  onChange,
  readOnly,
  required,
  hideFooter,
  removeAllowed,
}: HfOptionBuilderProps) => {
  return (
    <OdinController
      name={name}
      defaultValue={value}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <OptionBuilder
          id={id}
          data={data}
          value={value}
          textField={textField}
          valueField={valueField}
          onChange={onChange}
          label={label}
          readOnly={readOnly}
          required={required}
          hideFooter={hideFooter}
          removeAllowed={removeAllowed}
          error={error?.message}
        />
      )}
    />
  );
};

export default HfOptionBuilder;
